import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import { OFFICIAL_URL } from '@src/constants/business';
import DropDownMenu from './dropDownMenu';
import Store from './store';

const styles = require('./index.less');

/**
 * NaviBar
 * @param className
 * @param store {NaviBarStore}
 * @returns {JSX.Element}
 * @constructor
 */
export default wrapStore(({ className, store }) => {
  store.use();
  const { navList, dropDownMenuStore } = store;

  const renderSwitch = ({ title }, index) => {
    return (
      <div onClick={() => store.onNavClick(index)} key={index} className={cx(styles.navBtn, { [styles.isActive]: store.activeIndex === index })}>
        <div className={styles.navTitle}>{title}</div>
      </div>
    );
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 100 }}>
      <div className={cx(styles.navRoot, className, store.isSticky && styles.sticky)}>
        <DropDownMenu store={dropDownMenuStore} isSticky={store.isSticky} />
        <div className={cx(styles.navbarMain, !dropDownMenuStore.isExpand && styles.active)}>
          <div className={styles.nbLeftGroup} onMouseOver={() => dropDownMenuStore.onLogoMenuHover()}>
            <img className={styles.seasunLogo} alt="西山居" src={require('./images/normal-seasun-logo.png')} />
            <div className={styles.dropDownIcon} />
          </div>
          <div className={styles.nbRightGroup}>
            <div className={styles.groupLeft}>
              <div className={styles.logo} />
              <div className={styles.navList}>{navList.map((item, index) => renderSwitch(item, index))}</div>
            </div>
            <div className={styles.groupRight}>
              <Link onClick={store.onDownloadClick} className={styles.btnDownload} />
              <Link href={OFFICIAL_URL} target="_blank" className={styles.btnOfficial} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}, Store);
